import { c as _c } from "react/compiler-runtime";
import BannerPictureComponent, { BannerPicture } from '../banner-picture/banner-picture.component';
import CarouselComponent, { CarouselType } from '../carousel/carousel.component';
import { Fragment, ReactElement, memo } from 'react';
import HeadlineComponent, { Props as HeadlineProps } from '../headline/headline.component';
import LinkComponent, { getNoTrackIntersectionLink } from '../link/link.component';
import { CmsComponentContext } from '../container/CmsComponentContext';
import ConfigurableCmsComponentMetadata from '../../top-level-components/cms-page/metadata/configurable/configurable-cms-component-metadata.component';
import ConfigurableCmsSlotMetadata from '@spa/top-level-components/cms-page/metadata/configurable/configurable-cms-slot-metadata.component';
import ConfigurableCmsValidity from '@spa/top-level-components/cms-page/metadata/configurable/configurable-cms-validity.component';
import { Metadata } from '@spa/pages-converters/cms/component-envelops/CmsComponentEnvelopBase';
import { PictureBreakpoints } from '../picture/picture.component';
import classNames from 'clsx';
import styles from './combi-banner.component.module.scss';
export interface CombiBannerItem {
  readonly headline: HeadlineProps;
  readonly images: BannerPicture;
  readonly metadata: ReadonlyArray<Metadata>;
  readonly dateTo: number | null;
  readonly dateFrom: number | null;
}
export interface Props {
  readonly id: string;
  readonly editorMode: boolean;
  readonly optionalHeadline: HeadlineProps | null;
  readonly mobileSlider: boolean;
  readonly banners: ReadonlyArray<CombiBannerItem>;
  readonly bannersMetadata: ReadonlyArray<Metadata>;
  readonly scaleImageBeyondIntrinsicDimensions?: boolean;
  readonly dateTo: number | null;
  readonly dateFrom: number | null;
  readonly priority: boolean;
}
function CombiBannerComponent(t0) {
  const $ = _c(45);
  const {
    id,
    editorMode,
    optionalHeadline,
    mobileSlider,
    banners,
    bannersMetadata,
    scaleImageBeyondIntrinsicDimensions: t1,
    dateTo,
    dateFrom,
    priority
  } = t0;
  const scaleImageBeyondIntrinsicDimensions = t1 === undefined ? true : t1;
  let t2;
  if ($[0] !== banners.length || $[1] !== mobileSlider) {
    t2 = classNames([styles["combi-banner__items"]], {
      [styles["combi-banner__items--mobile-slider"]]: mobileSlider,
      [styles["combi-banner__items--five"]]: banners.length === 5,
      [styles["combi-banner__items--four"]]: banners.length === 4,
      [styles["combi-banner__items--three"]]: banners.length === 3,
      [styles["combi-banner__items--two"]]: banners.length === 2
    });
    $[0] = banners.length;
    $[1] = mobileSlider;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const bannerClasses = t2;
  let t3;
  if ($[3] !== scaleImageBeyondIntrinsicDimensions) {
    t3 = (banner, priority_0) => <BannerPictureComponent picture={banner.images} priority={priority_0} fixedBreakPoint={PictureBreakpoints.MOBILE} scaleImageBeyondIntrinsicDimensions={scaleImageBeyondIntrinsicDimensions} />;
    $[3] = scaleImageBeyondIntrinsicDimensions;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const bannerPicture = t3;
  let t4;
  if ($[5] !== bannerPicture || $[6] !== editorMode) {
    t4 = (banner_0, bannerIndex, priority_1) => {
      const {
        id: id_0,
        headline,
        subHeadline,
        link
      } = banner_0.headline;
      const {
        dateTo: dateTo_0,
        dateFrom: dateFrom_0
      } = banner_0;
      return <Fragment key={bannerIndex}><div className={styles["combi-banner__item"]}>{editorMode && <><ConfigurableCmsComponentMetadata beforeComponent={true} metadata={banner_0.metadata} /><ConfigurableCmsValidity dateFrom={dateFrom_0} dateTo={dateTo_0} /></>}{link !== null ? <LinkComponent link={link} className={styles["combi-banner__item-link"]}>{bannerPicture(banner_0, priority_1)}</LinkComponent> : bannerPicture(banner_0, priority_1)}<HeadlineComponent id={`${id_0}-headline`} headline={headline} subHeadline={subHeadline} link={getNoTrackIntersectionLink(link)} context={CmsComponentContext.BANNER} className={styles["combi-banner__item-headline"]} />{editorMode && <ConfigurableCmsComponentMetadata beforeComponent={false} metadata={banner_0.metadata} />}</div></Fragment>;
    };
    $[5] = bannerPicture;
    $[6] = editorMode;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const singleBanner = t4;
  let t5;
  if ($[8] !== dateFrom || $[9] !== dateTo || $[10] !== editorMode) {
    t5 = editorMode && <ConfigurableCmsValidity dateFrom={dateFrom} dateTo={dateTo} />;
    $[8] = dateFrom;
    $[9] = dateTo;
    $[10] = editorMode;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== optionalHeadline) {
    t6 = optionalHeadline && <HeadlineComponent id={optionalHeadline.id} headline={optionalHeadline.headline} subHeadline={optionalHeadline.subHeadline} link={optionalHeadline.link} />;
    $[12] = optionalHeadline;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== bannersMetadata || $[15] !== editorMode) {
    t7 = editorMode && <ConfigurableCmsSlotMetadata beforeSlot={true} metadata={bannersMetadata} />;
    $[14] = bannersMetadata;
    $[15] = editorMode;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== banners || $[18] !== priority || $[19] !== singleBanner) {
    let t9;
    if ($[21] !== priority || $[22] !== singleBanner) {
      t9 = (banner_1, bannerIndex_0) => singleBanner(banner_1, bannerIndex_0, priority);
      $[21] = priority;
      $[22] = singleBanner;
      $[23] = t9;
    } else {
      t9 = $[23];
    }
    t8 = banners.map(t9);
    $[17] = banners;
    $[18] = priority;
    $[19] = singleBanner;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  let t9;
  if ($[24] !== bannerClasses || $[25] !== t8) {
    t9 = <div className={bannerClasses} data-testid="combi-banner-banners">{t8}</div>;
    $[24] = bannerClasses;
    $[25] = t8;
    $[26] = t9;
  } else {
    t9 = $[26];
  }
  let t10;
  if ($[27] !== banners || $[28] !== id || $[29] !== mobileSlider || $[30] !== priority || $[31] !== singleBanner) {
    t10 = mobileSlider && <div className={styles["combi-banner__carousel"]}><CarouselComponent id={`${id}-carousel`} carouselType={CarouselType.BANNER} navigation={false}>{banners.map((banner_2, bannerIndex_1) => singleBanner(banner_2, bannerIndex_1, priority && bannerIndex_1 < 3))}</CarouselComponent></div>;
    $[27] = banners;
    $[28] = id;
    $[29] = mobileSlider;
    $[30] = priority;
    $[31] = singleBanner;
    $[32] = t10;
  } else {
    t10 = $[32];
  }
  let t11;
  if ($[33] !== t10 || $[34] !== t9) {
    t11 = <div>{t9}{t10}</div>;
    $[33] = t10;
    $[34] = t9;
    $[35] = t11;
  } else {
    t11 = $[35];
  }
  let t12;
  if ($[36] !== bannersMetadata || $[37] !== editorMode) {
    t12 = editorMode && <ConfigurableCmsSlotMetadata beforeSlot={false} metadata={bannersMetadata} />;
    $[36] = bannersMetadata;
    $[37] = editorMode;
    $[38] = t12;
  } else {
    t12 = $[38];
  }
  let t13;
  if ($[39] !== t11 || $[40] !== t12 || $[41] !== t5 || $[42] !== t6 || $[43] !== t7) {
    t13 = <div className={styles["combi-banner"]}>{t5}{t6}{t7}{t11}{t12}</div>;
    $[39] = t11;
    $[40] = t12;
    $[41] = t5;
    $[42] = t6;
    $[43] = t7;
    $[44] = t13;
  } else {
    t13 = $[44];
  }
  return t13;
}
export default memo(CombiBannerComponent);